/* eslint-disable */

import {
    SuiAbstractType,
    SuiSelectControlComponent,
    SuiTypeEnum,
    SuiTypeMultipleSelect,
    SuiTypeNumber,
    SuiTypeString,
    SuiTypeToggle
} from '@siklu/sui-lib/infrastructure';
import {
    AssignmentMethodEnum,
    AutoDesignP2MPDTO,
    AutoSetFrequenciesDTO,
    CcmIntervalEnum,
    ConfigObjectsDTO,
    ConfigPropertiesDTO,
    CostFunctionEnum,
    CustomerDTO,
    CustomerIdWithNameProjection,
    CustomerLocationDTO,
    CustomerRestrictionsDTO,
    DesignRingsDTO,
    EngineAntennaDTO,
    EngineAntennaTypeEnum,
    EngineProcessTypeEnum,
    EngineProductDTO,
    ExportLinkConfigDTO,
    ManagedUserVM,
    PdbBandTypeEnum,
    PdbChannelBandwidthEnum,
    PdbChannelConfigDTO,
    PdbChannelFrequenciesEnum,
    PdbEngineProductDTO,
    PdbEngineProductSectorConfigDTO,
    PdbFddOffsetEnum,
    PdbOperationModeNameEnum,
    PdbOpModeConfigDTO,
    PlannerFeatureCollectionDTO,
    PoeSupportEnum,
    PortNameEnum,
    PortSpeedEnum,
    PortTypeEnum,
    ProductPortDto,
    ProductServiceTypeEnum,
    ProductTypeEnum,
    ProjectDTO,
    RingdesPolarizationEnum,
    SupportedSnmpVersionEnum,
    SynchronizationModeEnum,
    TopologyPreferencesDTO,
    UserDTO
} from './shared-types.model';
SuiAbstractType.VALIDATION_MESSAGES_ENABLED = true;
SuiSelectControlComponent.FIT_DROPDOWN_WIDTH_TO_CONTROL_WIDTH = false;

export class SuiAutoDesignP2MPDTO {
    as_method: SuiTypeEnum<AssignmentMethodEnum>;
    bottom_up: SuiTypeToggle;
    buDeviceAzimuth: SuiTypeNumber;
    cap_fac: SuiTypeNumber;
    cost_fac: SuiTypeNumber;
    feed_by: SuiTypeNumber;
    layer_idx: SuiTypeNumber;
    lcent_dist: SuiTypeNumber;
    lim_boxes: SuiTypeToggle;
    max_dev_num: SuiTypeNumber;
    n_cand_win: SuiTypeNumber;
    num_dev_fac: SuiTypeNumber;
    opt_bs_fac: SuiTypeNumber;
    p2p_dist_fac: SuiTypeNumber;
    peer_bs_fac: SuiTypeNumber;
    pole_block: SuiTypeNumber;
    pop_dist_fac: SuiTypeNumber;
    pref_forced: SuiTypeToggle;
    rand_fac: SuiTypeNumber;
    rand_seed: SuiTypeNumber;
    redun_fac: SuiTypeNumber;
    rev_feed_fac: SuiTypeNumber;
    take_rate: SuiTypeNumber;
    tg_max_ittr: SuiTypeNumber;
    tunnel_fac: SuiTypeNumber;

    constructor(data: AutoDesignP2MPDTO) {
        this.as_method = new SuiTypeEnum(
            data.as_method,
            [AssignmentMethodEnum.RANDOM, AssignmentMethodEnum.EQUALIZE, AssignmentMethodEnum.WINNER_TAKES_ALL],
            'AssignmentMethodEnum'
        );
        this.bottom_up = new SuiTypeToggle(data.bottom_up, true, false);
        this.buDeviceAzimuth = new SuiTypeNumber(data.buDeviceAzimuth, 0, -2.147483648e9, 2.147483647e9);
        this.cap_fac = new SuiTypeNumber(data.cap_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.cost_fac = new SuiTypeNumber(data.cost_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.feed_by = new SuiTypeNumber(data.feed_by, 0, -2.147483648e9, 2.147483647e9);
        this.layer_idx = new SuiTypeNumber(data.layer_idx, undefined, -2.147483648e9, 2.147483647e9);
        this.lcent_dist = new SuiTypeNumber(data.lcent_dist, undefined, -2.147483648e9, 2.147483647e9);
        this.lim_boxes = new SuiTypeToggle(data.lim_boxes, true, false);
        this.max_dev_num = new SuiTypeNumber(data.max_dev_num, undefined, -2.147483648e9, 2.147483647e9);
        this.n_cand_win = new SuiTypeNumber(data.n_cand_win, undefined, -2.147483648e9, 2.147483647e9);
        this.num_dev_fac = new SuiTypeNumber(data.num_dev_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.opt_bs_fac = new SuiTypeNumber(data.opt_bs_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.p2p_dist_fac = new SuiTypeNumber(data.p2p_dist_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.peer_bs_fac = new SuiTypeNumber(data.peer_bs_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.pole_block = new SuiTypeNumber(data.pole_block, 40, -2.147483648e9, 2.147483647e9);
        this.pop_dist_fac = new SuiTypeNumber(data.pop_dist_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.pref_forced = new SuiTypeToggle(data.pref_forced, true, false);
        this.rand_fac = new SuiTypeNumber(data.rand_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.rand_seed = new SuiTypeNumber(data.rand_seed, 0, -2.147483648e9, 2.147483647e9);
        this.redun_fac = new SuiTypeNumber(data.redun_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.rev_feed_fac = new SuiTypeNumber(data.rev_feed_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.take_rate = new SuiTypeNumber(data.take_rate, undefined, -2.147483648e9, 2.147483647e9);
        this.tg_max_ittr = new SuiTypeNumber(data.tg_max_ittr, undefined, -2.147483648e9, 2.147483647e9);
        this.tunnel_fac = new SuiTypeNumber(data.tunnel_fac, undefined, -2.147483648e9, 2.147483647e9);
    }

    toDto(): AutoDesignP2MPDTO {
        return {
            as_method: this.as_method.value,
            bottom_up: this.bottom_up.value,
            buDeviceAzimuth: this.buDeviceAzimuth.value,
            cap_fac: this.cap_fac.value,
            cost_fac: this.cost_fac.value,
            feed_by: this.feed_by.value,
            layer_idx: this.layer_idx.value,
            lcent_dist: this.lcent_dist.value,
            lim_boxes: this.lim_boxes.value,
            max_dev_num: this.max_dev_num.value,
            n_cand_win: this.n_cand_win.value,
            num_dev_fac: this.num_dev_fac.value,
            opt_bs_fac: this.opt_bs_fac.value,
            p2p_dist_fac: this.p2p_dist_fac.value,
            peer_bs_fac: this.peer_bs_fac.value,
            pole_block: this.pole_block.value,
            pop_dist_fac: this.pop_dist_fac.value,
            pref_forced: this.pref_forced.value,
            rand_fac: this.rand_fac.value,
            rand_seed: this.rand_seed.value,
            redun_fac: this.redun_fac.value,
            rev_feed_fac: this.rev_feed_fac.value,
            take_rate: this.take_rate.value,
            tg_max_ittr: this.tg_max_ittr.value,
            tunnel_fac: this.tunnel_fac.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.as_method.validateAndShowError() &&
            this.bottom_up.validateAndShowError() &&
            this.buDeviceAzimuth.validateAndShowError() &&
            this.cap_fac.validateAndShowError() &&
            this.cost_fac.validateAndShowError() &&
            this.feed_by.validateAndShowError() &&
            this.layer_idx.validateAndShowError() &&
            this.lcent_dist.validateAndShowError() &&
            this.lim_boxes.validateAndShowError() &&
            this.max_dev_num.validateAndShowError() &&
            this.n_cand_win.validateAndShowError() &&
            this.num_dev_fac.validateAndShowError() &&
            this.opt_bs_fac.validateAndShowError() &&
            this.p2p_dist_fac.validateAndShowError() &&
            this.peer_bs_fac.validateAndShowError() &&
            this.pole_block.validateAndShowError() &&
            this.pop_dist_fac.validateAndShowError() &&
            this.pref_forced.validateAndShowError() &&
            this.rand_fac.validateAndShowError() &&
            this.rand_seed.validateAndShowError() &&
            this.redun_fac.validateAndShowError() &&
            this.rev_feed_fac.validateAndShowError() &&
            this.take_rate.validateAndShowError() &&
            this.tg_max_ittr.validateAndShowError() &&
            this.tunnel_fac.validateAndShowError()
        );
    }
}

export class SuiAutoSetFrequenciesDTO {
    explicit_only: SuiTypeToggle;
    force_new: SuiTypeToggle;
    pol_priority: SuiTypeToggle;
    pos_accuracy: SuiTypeNumber;
    rand_seed: SuiTypeNumber;
    wc_analysis: SuiTypeToggle;

    constructor(data: AutoSetFrequenciesDTO) {
        this.explicit_only = new SuiTypeToggle(data.explicit_only, true, false);
        this.force_new = new SuiTypeToggle(data.force_new, true, false);
        this.pol_priority = new SuiTypeToggle(data.pol_priority, true, false);
        this.pos_accuracy = new SuiTypeNumber(data.pos_accuracy, undefined, -2.147483648e9, 2.147483647e9);
        this.rand_seed = new SuiTypeNumber(data.rand_seed, undefined, -2.147483648e9, 2.147483647e9);
        this.wc_analysis = new SuiTypeToggle(data.wc_analysis, true, false);
    }

    toDto(): AutoSetFrequenciesDTO {
        return {
            explicit_only: this.explicit_only.value,
            force_new: this.force_new.value,
            pol_priority: this.pol_priority.value,
            pos_accuracy: this.pos_accuracy.value,
            rand_seed: this.rand_seed.value,
            wc_analysis: this.wc_analysis.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.explicit_only.validateAndShowError() &&
            this.force_new.validateAndShowError() &&
            this.pol_priority.validateAndShowError() &&
            this.pos_accuracy.validateAndShowError() &&
            this.rand_seed.validateAndShowError() &&
            this.wc_analysis.validateAndShowError()
        );
    }
}

export class SuiConfigObjectsDTO {
    properties: SuiConfigPropertiesDTO;
    type: string;

    constructor(data: ConfigObjectsDTO) {
        this.properties = new SuiConfigPropertiesDTO(data.properties ?? ({} as ConfigPropertiesDTO));
        this.type = data.type;
    }

    toDto(): ConfigObjectsDTO {
        return { properties: this.properties?.toDto(), type: this.type };
    }

    validateAndShowError(): boolean {
        return this.properties.validateAndShowError();
    }
}

export class SuiConfigPropertiesDTO {
    activeLayerIdx: number;
    autoSetFrequenciesPerLayer: AutoSetFrequenciesDTO[];
    autoconnectPerLayer: any[];
    autodesignP2mpPerLayer: AutoDesignP2MPDTO[];
    basic_discount: SuiTypeNumber;
    bomStepDisabled: SuiTypeToggle;
    configObjectVersion: string;
    defaultBuProductPerLayer: number[];
    defaultHeightPerLayer: number[];
    defaultTuProductPerLayer: number[];
    designError: any;
    designIterationsChartData: any[];
    designRingsPerLayer: DesignRingsDTO[];
    houseDetectionConfig: any;
    isBlockedByPole: boolean[];
    isShowPlanningMode: boolean;
    layers: any[];
    layersModeEnabled: SuiTypeToggle;
    locationNamePrefix: SuiTypeString;
    nodeNamesSectorsToShow: string[];
    nodesCountPerLayer: number[];
    predefined_devices_products: { [index: string]: string };
    productUnits: string;
    products_discounts: { [index: string]: number };
    saved_exportLinksConfig: SuiExportLinkConfigDTO;
    selectedDesignIteration: number;
    selectedProductsPerLayer: any[][];
    selectedServiceTypePerLayer: ProductServiceTypeEnum[];
    selectedServiceYearsPerLayer: number[];
    storedPolygons: { [index: string]: any[] };
    tuRequiredRatePerLayer: number[];

    constructor(data: ConfigPropertiesDTO) {
        this.activeLayerIdx = data.activeLayerIdx;
        this.autoSetFrequenciesPerLayer = data.autoSetFrequenciesPerLayer;
        this.autoconnectPerLayer = data.autoconnectPerLayer;
        this.autodesignP2mpPerLayer = data.autodesignP2mpPerLayer;
        this.basic_discount = new SuiTypeNumber(data.basic_discount, 0, 0.0, 100.0);
        this.basic_discount.isMandatory = true;
        this.bomStepDisabled = new SuiTypeToggle(data.bomStepDisabled, true, false);
        this.configObjectVersion = data.configObjectVersion;
        this.defaultBuProductPerLayer = data.defaultBuProductPerLayer;
        this.defaultHeightPerLayer = data.defaultHeightPerLayer;
        this.defaultTuProductPerLayer = data.defaultTuProductPerLayer;
        this.designError = data.designError;
        this.designIterationsChartData = data.designIterationsChartData;
        this.designRingsPerLayer = data.designRingsPerLayer;
        this.houseDetectionConfig = data.houseDetectionConfig;
        this.isBlockedByPole = data.isBlockedByPole;
        this.isShowPlanningMode = data.isShowPlanningMode;
        this.layers = data.layers;
        this.layersModeEnabled = new SuiTypeToggle(data.layersModeEnabled, true, false);
        this.locationNamePrefix = new SuiTypeString(
            data.locationNamePrefix,
            [new RegExp(/^[A-Za-z\d\s#@!;$&%()_+=.,~\-{}\[\]^'`]*$/)],
            0,
            50
        );
        this.locationNamePrefix.isMandatory = true;
        this.nodeNamesSectorsToShow = data.nodeNamesSectorsToShow;
        this.nodesCountPerLayer = data.nodesCountPerLayer;
        this.predefined_devices_products = data.predefined_devices_products;
        this.productUnits = data.productUnits;
        this.products_discounts = data.products_discounts;
        this.saved_exportLinksConfig = new SuiExportLinkConfigDTO(data.saved_exportLinksConfig ?? ({} as ExportLinkConfigDTO));
        this.selectedDesignIteration = data.selectedDesignIteration;
        this.selectedProductsPerLayer = data.selectedProductsPerLayer;
        this.selectedServiceTypePerLayer = data.selectedServiceTypePerLayer;
        this.selectedServiceYearsPerLayer = data.selectedServiceYearsPerLayer;
        this.storedPolygons = data.storedPolygons;
        this.tuRequiredRatePerLayer = data.tuRequiredRatePerLayer;
    }

    toDto(): ConfigPropertiesDTO {
        return {
            activeLayerIdx: this.activeLayerIdx,
            autoSetFrequenciesPerLayer: this.autoSetFrequenciesPerLayer,
            autoconnectPerLayer: this.autoconnectPerLayer,
            autodesignP2mpPerLayer: this.autodesignP2mpPerLayer,
            basic_discount: this.basic_discount.value,
            bomStepDisabled: this.bomStepDisabled.value,
            configObjectVersion: this.configObjectVersion,
            defaultBuProductPerLayer: this.defaultBuProductPerLayer,
            defaultHeightPerLayer: this.defaultHeightPerLayer,
            defaultTuProductPerLayer: this.defaultTuProductPerLayer,
            designError: this.designError,
            designIterationsChartData: this.designIterationsChartData,
            designRingsPerLayer: this.designRingsPerLayer,
            houseDetectionConfig: this.houseDetectionConfig,
            isBlockedByPole: this.isBlockedByPole,
            isShowPlanningMode: this.isShowPlanningMode,
            layers: this.layers,
            layersModeEnabled: this.layersModeEnabled.value,
            locationNamePrefix: this.locationNamePrefix.value,
            nodeNamesSectorsToShow: this.nodeNamesSectorsToShow,
            nodesCountPerLayer: this.nodesCountPerLayer,
            predefined_devices_products: this.predefined_devices_products,
            productUnits: this.productUnits,
            products_discounts: this.products_discounts,
            saved_exportLinksConfig: this.saved_exportLinksConfig?.toDto(),
            selectedDesignIteration: this.selectedDesignIteration,
            selectedProductsPerLayer: this.selectedProductsPerLayer,
            selectedServiceTypePerLayer: this.selectedServiceTypePerLayer,
            selectedServiceYearsPerLayer: this.selectedServiceYearsPerLayer,
            storedPolygons: this.storedPolygons,
            tuRequiredRatePerLayer: this.tuRequiredRatePerLayer
        };
    }

    validateAndShowError(): boolean {
        return (
            this.basic_discount.validateAndShowError() &&
            this.bomStepDisabled.validateAndShowError() &&
            this.layersModeEnabled.validateAndShowError() &&
            this.locationNamePrefix.validateAndShowError() &&
            this.saved_exportLinksConfig.validateAndShowError()
        );
    }
}

export class SuiCustomerDTO {
    blocked: SuiTypeToggle;
    bomExportDaysTimeout: SuiTypeNumber;
    childCompanies: SuiCustomerIdWithNameProjection[];
    designBomDaysTimeout: SuiTypeNumber;
    id: SuiTypeNumber;
    location: CustomerLocationDTO;
    name: SuiTypeString;
    numberOfProjects: SuiTypeNumber;
    numberOfUsers: SuiTypeNumber;
    parentCompany: SuiCustomerIdWithNameProjection;
    sales: SuiTypeMultipleSelect<UserDTO>;
    sikluCompany: SuiTypeToggle;

    constructor(data: CustomerDTO) {
        this.blocked = new SuiTypeToggle(data.blocked, true, false);
        this.bomExportDaysTimeout = new SuiTypeNumber(data.bomExportDaysTimeout, 0, 0.0, 10.0);
        this.childCompanies = (data.childCompanies ?? []).map(
            (value) => new SuiCustomerIdWithNameProjection(value ?? ({} as CustomerIdWithNameProjection))
        );
        this.designBomDaysTimeout = new SuiTypeNumber(data.designBomDaysTimeout, 0, 0.0, 10.0);
        this.id = new SuiTypeNumber(data.id, undefined, -2.147483648e9, 2.147483647e9);
        this.location = data.location;
        this.name = new SuiTypeString(data.name, [new RegExp(/^[A-Za-z\d\s_\-=+*\\|/?!@#$%^&()\[\]{}~.,><]*$/)], 1, 255);
        this.name.isMandatory = true;
        this.numberOfProjects = new SuiTypeNumber(data.numberOfProjects, 0, -2.147483648e9, 2.147483647e9);
        this.numberOfUsers = new SuiTypeNumber(data.numberOfUsers, 0, -2.147483648e9, 2.147483647e9);
        this.parentCompany = new SuiCustomerIdWithNameProjection(data.parentCompany ?? ({} as CustomerIdWithNameProjection));
        this.sales = new SuiTypeMultipleSelect([], data.sales ?? [], 'id');
        this.sales.isMandatory = true;
        this.sikluCompany = new SuiTypeToggle(data.sikluCompany, true, false);
    }

    toDto(): CustomerDTO {
        return {
            blocked: this.blocked.value,
            bomExportDaysTimeout: this.bomExportDaysTimeout.value,
            childCompanies: this.childCompanies.map((typeValue: SuiCustomerIdWithNameProjection) => typeValue.toDto()),
            designBomDaysTimeout: this.designBomDaysTimeout.value,
            id: this.id.value,
            location: this.location,
            name: this.name.value,
            numberOfProjects: this.numberOfProjects.value,
            numberOfUsers: this.numberOfUsers.value,
            parentCompany: this.parentCompany?.toDto(),
            sales: this.sales.value,
            sikluCompany: this.sikluCompany.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.blocked.validateAndShowError() &&
            this.bomExportDaysTimeout.validateAndShowError() &&
            this.childCompanies.every((element: SuiCustomerIdWithNameProjection) => element.validateAndShowError()) &&
            this.designBomDaysTimeout.validateAndShowError() &&
            this.id.validateAndShowError() &&
            this.name.validateAndShowError() &&
            this.numberOfProjects.validateAndShowError() &&
            this.numberOfUsers.validateAndShowError() &&
            this.parentCompany.validateAndShowError() &&
            this.sales.validateAndShowError() &&
            this.sikluCompany.validateAndShowError()
        );
    }
}

export class SuiCustomerIdWithNameProjection {
    id: SuiTypeNumber;
    name: SuiTypeString;

    constructor(data: CustomerIdWithNameProjection) {
        this.id = new SuiTypeNumber(data.id, undefined, -2.147483648e9, 2.147483647e9);
        this.name = new SuiTypeString(data.name, undefined, 0, 2147483647);
    }

    toDto(): CustomerIdWithNameProjection {
        return { id: this.id.value, name: this.name.value };
    }

    validateAndShowError(): boolean {
        return this.id.validateAndShowError() && this.name.validateAndShowError();
    }
}

export class SuiCustomerLocationDTO {
    currency: string;
    id: string;
    name: SuiTypeString;

    constructor(data: CustomerLocationDTO) {
        this.currency = data.currency;
        this.id = data.id;
        this.name = new SuiTypeString(data.name, undefined, 1, 255);
        this.name.isMandatory = true;
    }

    toDto(): CustomerLocationDTO {
        return { currency: this.currency, id: this.id, name: this.name.value };
    }

    validateAndShowError(): boolean {
        return this.name.validateAndShowError();
    }
}

export class SuiCustomerRestrictionsDTO {
    adminUserLimit: SuiTypeNumber;
    exportEnabled: SuiTypeToggle;
    id: SuiTypeNumber;
    name: SuiTypeString;
    plannerUserLimit: SuiTypeNumber;
    projectLocationsLimit: SuiTypeNumber;
    projectsLimit: SuiTypeNumber;

    constructor(data: CustomerRestrictionsDTO) {
        this.adminUserLimit = new SuiTypeNumber(data.adminUserLimit, 0, 0.0, 100.0);
        this.exportEnabled = new SuiTypeToggle(data.exportEnabled, true, false);
        this.id = new SuiTypeNumber(data.id, undefined, -2.147483648e9, 2.147483647e9);
        this.name = new SuiTypeString(data.name ? data.name : 'default', [new RegExp(/^[a-zA-Z0-9 ]*$/)], 1, 255);
        this.plannerUserLimit = new SuiTypeNumber(data.plannerUserLimit, 0, 0.0, 100.0);
        this.projectLocationsLimit = new SuiTypeNumber(data.projectLocationsLimit, 0, 0.0, 100000.0);
        this.projectsLimit = new SuiTypeNumber(data.projectsLimit, 0, 0.0, 100.0);
    }

    toDto(): CustomerRestrictionsDTO {
        return {
            adminUserLimit: this.adminUserLimit.value,
            exportEnabled: this.exportEnabled.value,
            id: this.id.value,
            name: this.name.value,
            plannerUserLimit: this.plannerUserLimit.value,
            projectLocationsLimit: this.projectLocationsLimit.value,
            projectsLimit: this.projectsLimit.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.adminUserLimit.validateAndShowError() &&
            this.exportEnabled.validateAndShowError() &&
            this.id.validateAndShowError() &&
            this.name.validateAndShowError() &&
            this.plannerUserLimit.validateAndShowError() &&
            this.projectLocationsLimit.validateAndShowError() &&
            this.projectsLimit.validateAndShowError()
        );
    }
}

export class SuiDesignRingsDTO {
    bottom_up: SuiTypeToggle;
    dist_lim: SuiTypeNumber;
    layer_idx: SuiTypeNumber;
    lpn_fac: SuiTypeNumber;
    lpn_func: SuiTypeEnum<CostFunctionEnum>;
    lpn_th: SuiTypeNumber;
    lpn_weig: SuiTypeNumber;
    noh_fac: SuiTypeNumber;
    noh_func: SuiTypeEnum<CostFunctionEnum>;
    noh_th: SuiTypeNumber;
    noh_weig: SuiTypeNumber;
    opn_weig: SuiTypeNumber;
    rand_seed: SuiTypeNumber;
    rsz_th: SuiTypeNumber;
    rsz_weig: SuiTypeNumber;
    supp_layer: SuiTypeNumber;
    use_dlim: SuiTypeToggle;

    constructor(data: DesignRingsDTO) {
        this.bottom_up = new SuiTypeToggle(data.bottom_up, true, false);
        this.dist_lim = new SuiTypeNumber(data.dist_lim, undefined, -2.147483648e9, 2.147483647e9);
        this.layer_idx = new SuiTypeNumber(data.layer_idx, undefined, -2.147483648e9, 2.147483647e9);
        this.lpn_fac = new SuiTypeNumber(data.lpn_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.lpn_func = new SuiTypeEnum(data.lpn_func, [CostFunctionEnum.EXPONENTIAL, CostFunctionEnum.POLYNOMIAL], 'CostFunctionEnum');
        this.lpn_th = new SuiTypeNumber(data.lpn_th, undefined, -2.147483648e9, 2.147483647e9);
        this.lpn_weig = new SuiTypeNumber(data.lpn_weig, undefined, -2.147483648e9, 2.147483647e9);
        this.noh_fac = new SuiTypeNumber(data.noh_fac, undefined, -2.147483648e9, 2.147483647e9);
        this.noh_func = new SuiTypeEnum(data.noh_func, [CostFunctionEnum.EXPONENTIAL, CostFunctionEnum.POLYNOMIAL], 'CostFunctionEnum');
        this.noh_th = new SuiTypeNumber(data.noh_th, undefined, -2.147483648e9, 2.147483647e9);
        this.noh_weig = new SuiTypeNumber(data.noh_weig, undefined, -2.147483648e9, 2.147483647e9);
        this.opn_weig = new SuiTypeNumber(data.opn_weig, undefined, -2.147483648e9, 2.147483647e9);
        this.rand_seed = new SuiTypeNumber(data.rand_seed, 0, -2.147483648e9, 2.147483647e9);
        this.rsz_th = new SuiTypeNumber(data.rsz_th, undefined, -2.147483648e9, 2.147483647e9);
        this.rsz_weig = new SuiTypeNumber(data.rsz_weig, undefined, -2.147483648e9, 2.147483647e9);
        this.supp_layer = new SuiTypeNumber(data.supp_layer, undefined, -2.147483648e9, 2.147483647e9);
        this.use_dlim = new SuiTypeToggle(data.use_dlim, true, false);
    }

    toDto(): DesignRingsDTO {
        return {
            bottom_up: this.bottom_up.value,
            dist_lim: this.dist_lim.value,
            layer_idx: this.layer_idx.value,
            lpn_fac: this.lpn_fac.value,
            lpn_func: this.lpn_func.value,
            lpn_th: this.lpn_th.value,
            lpn_weig: this.lpn_weig.value,
            noh_fac: this.noh_fac.value,
            noh_func: this.noh_func.value,
            noh_th: this.noh_th.value,
            noh_weig: this.noh_weig.value,
            opn_weig: this.opn_weig.value,
            rand_seed: this.rand_seed.value,
            rsz_th: this.rsz_th.value,
            rsz_weig: this.rsz_weig.value,
            supp_layer: this.supp_layer.value,
            use_dlim: this.use_dlim.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.bottom_up.validateAndShowError() &&
            this.dist_lim.validateAndShowError() &&
            this.layer_idx.validateAndShowError() &&
            this.lpn_fac.validateAndShowError() &&
            this.lpn_func.validateAndShowError() &&
            this.lpn_th.validateAndShowError() &&
            this.lpn_weig.validateAndShowError() &&
            this.noh_fac.validateAndShowError() &&
            this.noh_func.validateAndShowError() &&
            this.noh_th.validateAndShowError() &&
            this.noh_weig.validateAndShowError() &&
            this.opn_weig.validateAndShowError() &&
            this.rand_seed.validateAndShowError() &&
            this.rsz_th.validateAndShowError() &&
            this.rsz_weig.validateAndShowError() &&
            this.supp_layer.validateAndShowError() &&
            this.use_dlim.validateAndShowError()
        );
    }
}

export class SuiEngineAntennaDTO {
    antennaType: SuiTypeEnum<EngineAntennaTypeEnum>;
    engineId: SuiTypeNumber;
    id: SuiTypeNumber;
    name: SuiTypeString;
    pdbName: SuiTypeString;

    constructor(data: EngineAntennaDTO) {
        this.antennaType = new SuiTypeEnum(
            data.antennaType,
            [EngineAntennaTypeEnum.NORMAL, EngineAntennaTypeEnum.DL5],
            'EngineAntennaTypeEnum'
        );
        this.engineId = new SuiTypeNumber(data.engineId, 0, -2.147483648e9, 2.147483647e9);
        this.id = new SuiTypeNumber(data.id, undefined, -2.147483648e9, 2.147483647e9);
        this.name = new SuiTypeString(data.name, undefined, 0, 2147483647);
        this.pdbName = new SuiTypeString(data.pdbName, undefined, 0, 2147483647);
    }

    toDto(): EngineAntennaDTO {
        return {
            antennaType: this.antennaType.value,
            engineId: this.engineId.value,
            id: this.id.value,
            name: this.name.value,
            pdbName: this.pdbName.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.antennaType.validateAndShowError() &&
            this.engineId.validateAndShowError() &&
            this.id.validateAndShowError() &&
            this.name.validateAndShowError() &&
            this.pdbName.validateAndShowError()
        );
    }
}

export class SuiEngineProductDTO {
    id: number;
    isBU: boolean;
    isPtP: boolean;
    isTU: boolean;
    name: SuiTypeString;
    pdbConfig: SuiPdbEngineProductDTO;
    productType: SuiTypeEnum<ProductTypeEnum>;
    radioOrder: number;

    constructor(data: EngineProductDTO) {
        this.id = data.id;
        this.isBU = data.isBU;
        this.isPtP = data.isPtP;
        this.isTU = data.isTU;
        this.name = new SuiTypeString(data.name, undefined, 1, 255);
        this.pdbConfig = new SuiPdbEngineProductDTO(data.pdbConfig ?? ({} as PdbEngineProductDTO));
        this.productType = new SuiTypeEnum(
            data.productType,
            [ProductTypeEnum.EH, ProductTypeEnum.MH, ProductTypeEnum.TG_MH],
            'ProductTypeEnum'
        );
        this.radioOrder = data.radioOrder;
    }

    toDto(): EngineProductDTO {
        return {
            id: this.id,
            isBU: this.isBU,
            isPtP: this.isPtP,
            isTU: this.isTU,
            name: this.name.value,
            pdbConfig: this.pdbConfig?.toDto(),
            productType: this.productType.value,
            radioOrder: this.radioOrder
        };
    }

    validateAndShowError(): boolean {
        return this.name.validateAndShowError() && this.pdbConfig.validateAndShowError() && this.productType.validateAndShowError();
    }
}

export class SuiExportLinkConfigDTO {
    ccmInterval: CcmIntervalEnum;
    defaultGateway: SuiTypeString;
    engineId: string;
    ipLessTu: boolean;
    managementVid: SuiTypeNumber;
    mng_uname: string;
    mng_upass: string;
    pasw: string;
    rapsVid: number;
    snmpIP: SuiTypeString;
    snmpVersion: SuiTypeEnum<SupportedSnmpVersionEnum>;
    ssid: string;
    ssidpw: string;
    startIp: SuiTypeString;
    startVid: number;
    subnetMask: SuiTypeNumber;
    timezone: string;
    trap: SuiTypeString;
    udpPort: SuiTypeNumber;
    vidPerRing: number;

    constructor(data: ExportLinkConfigDTO) {
        this.ccmInterval = data.ccmInterval;
        this.defaultGateway = new SuiTypeString(
            data.defaultGateway ? data.defaultGateway : '10.0.0.1',
            [new RegExp(/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/)],
            0,
            2147483647
        );
        this.engineId = data.engineId;
        this.ipLessTu = data.ipLessTu;
        this.managementVid = new SuiTypeNumber(data.managementVid, undefined, 1.0, 4094.0);
        this.mng_uname = data.mng_uname;
        this.mng_upass = data.mng_upass;
        this.pasw = data.pasw;
        this.rapsVid = data.rapsVid;
        this.snmpIP = new SuiTypeString(data.snmpIP, [new RegExp(/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/)], 0, 2147483647);
        this.snmpVersion = new SuiTypeEnum(
            data.snmpVersion,
            [SupportedSnmpVersionEnum.V2C, SupportedSnmpVersionEnum.V3],
            'SupportedSnmpVersionEnum'
        );
        this.ssid = data.ssid;
        this.ssidpw = data.ssidpw;
        this.startIp = new SuiTypeString(
            data.startIp ? data.startIp : '10.0.0.2',
            [new RegExp(/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/)],
            0,
            2147483647
        );
        this.startVid = data.startVid;
        this.subnetMask = new SuiTypeNumber(data.subnetMask, 24, 0.0, 32.0);
        this.timezone = data.timezone;
        this.trap = new SuiTypeString(data.trap, undefined, 0, 2147483647);
        this.udpPort = new SuiTypeNumber(data.udpPort, undefined, 0.0, 64000.0);
        this.vidPerRing = data.vidPerRing;
    }

    toDto(): ExportLinkConfigDTO {
        return {
            ccmInterval: this.ccmInterval,
            defaultGateway: this.defaultGateway.value,
            engineId: this.engineId,
            ipLessTu: this.ipLessTu,
            managementVid: this.managementVid.value,
            mng_uname: this.mng_uname,
            mng_upass: this.mng_upass,
            pasw: this.pasw,
            rapsVid: this.rapsVid,
            snmpIP: this.snmpIP.value,
            snmpVersion: this.snmpVersion.value,
            ssid: this.ssid,
            ssidpw: this.ssidpw,
            startIp: this.startIp.value,
            startVid: this.startVid,
            subnetMask: this.subnetMask.value,
            timezone: this.timezone,
            trap: this.trap.value,
            udpPort: this.udpPort.value,
            vidPerRing: this.vidPerRing
        };
    }

    validateAndShowError(): boolean {
        return (
            this.defaultGateway.validateAndShowError() &&
            this.managementVid.validateAndShowError() &&
            this.snmpIP.validateAndShowError() &&
            this.snmpVersion.validateAndShowError() &&
            this.startIp.validateAndShowError() &&
            this.subnetMask.validateAndShowError() &&
            this.trap.validateAndShowError() &&
            this.udpPort.validateAndShowError()
        );
    }
}

export class SuiUserDTO {
    authorities: SuiTypeString[];
    createdBy: SuiTypeString;
    createdDate: Date;
    customerId: SuiTypeNumber;
    emailVerificationRequired: boolean;
    eulaAcceptanceRequired: boolean;
    firstName: SuiTypeString;
    id: SuiTypeNumber;
    lastAuthDate: Date;
    lastModifiedBy: SuiTypeString;
    lastModifiedDate: Date;
    lastName: SuiTypeString;
    login: SuiTypeString;

    constructor(data: UserDTO) {
        this.authorities = (data.authorities ?? []).map((value) => new SuiTypeString(value ? value : '[]', undefined, 1, 50));
        this.createdBy = new SuiTypeString(data.createdBy, undefined, 0, 2147483647);
        this.createdDate = data.createdDate;
        this.customerId = new SuiTypeNumber(data.customerId, undefined, 1.0, 2.147483647e9);
        this.emailVerificationRequired = data.emailVerificationRequired;
        this.eulaAcceptanceRequired = data.eulaAcceptanceRequired;
        this.firstName = new SuiTypeString(data.firstName, undefined, 0, 50);
        this.id = new SuiTypeNumber(data.id, undefined, 1.0, 2.147483647e9);
        this.lastAuthDate = data.lastAuthDate;
        this.lastModifiedBy = new SuiTypeString(data.lastModifiedBy, undefined, 0, 2147483647);
        this.lastModifiedDate = data.lastModifiedDate;
        this.lastName = new SuiTypeString(data.lastName, undefined, 0, 50);
        this.login = new SuiTypeString(
            data.login,
            [
                new RegExp(
                    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
                )
            ],
            1,
            50
        );
    }

    toDto(): UserDTO {
        return {
            authorities: this.authorities.map((element: SuiTypeString) => element.value),
            createdBy: this.createdBy.value,
            createdDate: this.createdDate,
            customerId: this.customerId.value,
            emailVerificationRequired: this.emailVerificationRequired,
            eulaAcceptanceRequired: this.eulaAcceptanceRequired,
            firstName: this.firstName.value,
            id: this.id.value,
            lastAuthDate: this.lastAuthDate,
            lastModifiedBy: this.lastModifiedBy.value,
            lastModifiedDate: this.lastModifiedDate,
            lastName: this.lastName.value,
            login: this.login.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.authorities.every((element: SuiTypeString) => element.validateAndShowError()) &&
            this.createdBy.validateAndShowError() &&
            this.customerId.validateAndShowError() &&
            this.firstName.validateAndShowError() &&
            this.id.validateAndShowError() &&
            this.lastModifiedBy.validateAndShowError() &&
            this.lastName.validateAndShowError() &&
            this.login.validateAndShowError()
        );
    }
}

export class SuiManagedUserVM extends SuiUserDTO {
    password: SuiTypeString;

    constructor(data: ManagedUserVM) {
        super(data);
        this.password = new SuiTypeString(data.password, undefined, 4, 50);
    }

    toDto(): ManagedUserVM {
        const data = super.toDto();
        return { ...data, password: this.password.value };
    }

    validateAndShowError(): boolean {
        return super.validateAndShowError() && this.password.validateAndShowError();
    }
}

export class SuiPdbChannelConfigDTO {
    bandwidth: SuiTypeEnum<PdbChannelBandwidthEnum>;
    frequencies: SuiTypeMultipleSelect<PdbChannelFrequenciesEnum>;
    opModeConfigs: SuiPdbOpModeConfigDTO[];

    constructor(data: PdbChannelConfigDTO) {
        this.bandwidth = new SuiTypeEnum(
            data.bandwidth,
            [
                PdbChannelBandwidthEnum.BW_2100,
                PdbChannelBandwidthEnum.BW_2000,
                PdbChannelBandwidthEnum.BW_1250,
                PdbChannelBandwidthEnum.BW_750,
                PdbChannelBandwidthEnum.BW_500,
                PdbChannelBandwidthEnum.BW_250,
                PdbChannelBandwidthEnum.BW_125
            ],
            'PdbChannelBandwidthEnum'
        );
        this.bandwidth.isMandatory = true;
        this.frequencies = new SuiTypeMultipleSelect([], data.frequencies ?? []);
        this.frequencies.isMandatory = true;
        this.opModeConfigs = (data.opModeConfigs ?? []).map((value) => new SuiPdbOpModeConfigDTO(value ?? ({} as PdbOpModeConfigDTO)));
    }

    toDto(): PdbChannelConfigDTO {
        return {
            bandwidth: this.bandwidth.value,
            frequencies: this.frequencies.value,
            opModeConfigs: this.opModeConfigs.map((typeValue: SuiPdbOpModeConfigDTO) => typeValue.toDto())
        };
    }

    validateAndShowError(): boolean {
        return (
            this.bandwidth.validateAndShowError() &&
            this.frequencies.validateAndShowError() &&
            this.opModeConfigs.every((element: SuiPdbOpModeConfigDTO) => element.validateAndShowError())
        );
    }
}

export class SuiPdbEngineProductDTO {
    antennas: SuiTypeMultipleSelect<EngineAntennaDTO>;
    channelConfigs: SuiPdbChannelConfigDTO[];
    description: SuiTypeString;
    ethPortSpeed: SuiTypeNumber;
    fddOffset: SuiTypeEnum<PdbFddOffsetEnum>;
    frequencyBand: SuiTypeEnum<PdbBandTypeEnum>;
    objectEmpty: SuiTypeToggle;
    polarization: SuiTypeEnum<RingdesPolarizationEnum>;
    pricePriority: SuiTypeNumber;
    productPorts: SuiProductPortDto[];
    resiliencySupported: SuiTypeToggle;
    sectorConfig: SuiPdbEngineProductSectorConfigDTO[];
    shortDescription: SuiTypeString;
    synchronizationMode: SuiTypeEnum<SynchronizationModeEnum>;

    constructor(data: PdbEngineProductDTO) {
        this.antennas = new SuiTypeMultipleSelect([], data.antennas ?? [], 'id');
        this.antennas.isMandatory = true;
        this.channelConfigs = (data.channelConfigs ?? []).map((value) => new SuiPdbChannelConfigDTO(value ?? ({} as PdbChannelConfigDTO)));
        this.description = new SuiTypeString(data.description, undefined, 0, 255);
        this.description.isMandatory = true;
        this.ethPortSpeed = new SuiTypeNumber(data.ethPortSpeed, undefined, 0.0, 2.147483647e9);
        this.fddOffset = new SuiTypeEnum(data.fddOffset, [PdbFddOffsetEnum.FALSE, PdbFddOffsetEnum.TRUE], 'PdbFddOffsetEnum');
        this.fddOffset.isMandatory = true;
        this.frequencyBand = new SuiTypeEnum(data.frequencyBand, [PdbBandTypeEnum.E_BAND, PdbBandTypeEnum.V_BAND], 'PdbBandTypeEnum');
        this.frequencyBand.isMandatory = true;
        this.objectEmpty = new SuiTypeToggle(data.objectEmpty, true, false);
        this.polarization = new SuiTypeEnum(
            data.polarization,
            [RingdesPolarizationEnum.VERTICAL, RingdesPolarizationEnum.HORIZONTAL],
            'RingdesPolarizationEnum'
        );
        this.polarization.isMandatory = true;
        this.pricePriority = new SuiTypeNumber(data.pricePriority, undefined, 0.0, 100.0);
        this.productPorts = (data.productPorts ?? []).map((value) => new SuiProductPortDto(value ?? ({} as ProductPortDto)));
        this.resiliencySupported = new SuiTypeToggle(data.resiliencySupported, true, false);
        this.sectorConfig = (data.sectorConfig ?? []).map(
            (value) => new SuiPdbEngineProductSectorConfigDTO(value ?? ({} as PdbEngineProductSectorConfigDTO))
        );
        this.shortDescription = new SuiTypeString(data.shortDescription, undefined, 0, 255);
        this.shortDescription.isMandatory = true;
        this.synchronizationMode = new SuiTypeEnum(
            data.synchronizationMode,
            [SynchronizationModeEnum.GPS, SynchronizationModeEnum.DPLL, SynchronizationModeEnum.NONE],
            'SynchronizationModeEnum'
        );
    }

    toDto(): PdbEngineProductDTO {
        return {
            antennas: this.antennas.value,
            channelConfigs: this.channelConfigs.map((typeValue: SuiPdbChannelConfigDTO) => typeValue.toDto()),
            description: this.description.value,
            ethPortSpeed: this.ethPortSpeed.value,
            fddOffset: this.fddOffset.value,
            frequencyBand: this.frequencyBand.value,
            objectEmpty: this.objectEmpty.value,
            polarization: this.polarization.value,
            pricePriority: this.pricePriority.value,
            productPorts: this.productPorts.map((typeValue: SuiProductPortDto) => typeValue.toDto()),
            resiliencySupported: this.resiliencySupported.value,
            sectorConfig: this.sectorConfig.map((typeValue: SuiPdbEngineProductSectorConfigDTO) => typeValue.toDto()),
            shortDescription: this.shortDescription.value,
            synchronizationMode: this.synchronizationMode.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.antennas.validateAndShowError() &&
            this.channelConfigs.every((element: SuiPdbChannelConfigDTO) => element.validateAndShowError()) &&
            this.description.validateAndShowError() &&
            this.ethPortSpeed.validateAndShowError() &&
            this.fddOffset.validateAndShowError() &&
            this.frequencyBand.validateAndShowError() &&
            this.objectEmpty.validateAndShowError() &&
            this.polarization.validateAndShowError() &&
            this.pricePriority.validateAndShowError() &&
            this.productPorts.every((element: SuiProductPortDto) => element.validateAndShowError()) &&
            this.resiliencySupported.validateAndShowError() &&
            this.sectorConfig.every((element: SuiPdbEngineProductSectorConfigDTO) => element.validateAndShowError()) &&
            this.shortDescription.validateAndShowError() &&
            this.synchronizationMode.validateAndShowError()
        );
    }
}

export class SuiPdbEngineProductSectorConfigDTO {
    azimuthOffset: number;
    direction: SuiTypeNumber;
    maxBu: SuiTypeNumber;
    maxTu: SuiTypeNumber;

    constructor(data: PdbEngineProductSectorConfigDTO) {
        this.azimuthOffset = data.azimuthOffset;
        this.direction = new SuiTypeNumber(data.direction, 0, 0.0, 359.0);
        this.maxBu = new SuiTypeNumber(data.maxBu, 0, 0.0, 1.0);
        this.maxTu = new SuiTypeNumber(data.maxTu, 0, 0.0, 15.0);
    }

    toDto(): PdbEngineProductSectorConfigDTO {
        return { azimuthOffset: this.azimuthOffset, direction: this.direction.value, maxBu: this.maxBu.value, maxTu: this.maxTu.value };
    }

    validateAndShowError(): boolean {
        return this.direction.validateAndShowError() && this.maxBu.validateAndShowError() && this.maxTu.validateAndShowError();
    }
}

export class SuiPdbOpModeConfigDTO {
    dataRate: SuiTypeNumber;
    id: SuiTypeNumber;
    isEnabled: SuiTypeToggle;
    modulationAlias: SuiTypeString;
    opModeName: SuiTypeEnum<PdbOperationModeNameEnum>;
    order: number;
    ptx: SuiTypeNumber;
    rxThreshold: SuiTypeNumber;
    usedBandwidth: SuiTypeNumber;

    constructor(data: PdbOpModeConfigDTO) {
        this.dataRate = new SuiTypeNumber(data.dataRate, undefined, 0.0, 2.147483647e9);
        this.id = new SuiTypeNumber(data.id, undefined, -2.147483648e9, 2.147483647e9);
        this.isEnabled = new SuiTypeToggle(data.isEnabled, true, false);
        this.modulationAlias = new SuiTypeString(data.modulationAlias, undefined, 0, 50);
        this.modulationAlias.isMandatory = true;
        this.opModeName = new SuiTypeEnum(
            data.opModeName,
            [
                PdbOperationModeNameEnum.QPSK_1_2,
                PdbOperationModeNameEnum.QAM16_1_2,
                PdbOperationModeNameEnum.QAM64_1_2,
                PdbOperationModeNameEnum.BPSKH,
                PdbOperationModeNameEnum.BPSKQ,
                PdbOperationModeNameEnum.BPSK,
                PdbOperationModeNameEnum.QPSK,
                PdbOperationModeNameEnum.QPSKQ,
                PdbOperationModeNameEnum.QAM16,
                PdbOperationModeNameEnum.QAM32,
                PdbOperationModeNameEnum.QAM64,
                PdbOperationModeNameEnum.QAM128,
                PdbOperationModeNameEnum.QPSKH,
                PdbOperationModeNameEnum.MCS0,
                PdbOperationModeNameEnum.MCS1,
                PdbOperationModeNameEnum.MCS2,
                PdbOperationModeNameEnum.MCS3,
                PdbOperationModeNameEnum.MCS4,
                PdbOperationModeNameEnum.MCS5,
                PdbOperationModeNameEnum.MCS6,
                PdbOperationModeNameEnum.MCS7,
                PdbOperationModeNameEnum.MCS8,
                PdbOperationModeNameEnum.MCS9,
                PdbOperationModeNameEnum.MCS10,
                PdbOperationModeNameEnum.MCS11,
                PdbOperationModeNameEnum.MCS12,
                PdbOperationModeNameEnum.PSK_8
            ],
            'PdbOperationModeNameEnum'
        );
        this.order = data.order;
        this.ptx = new SuiTypeNumber(data.ptx, undefined, 0.0, 2.147483647e9, 1);
        this.rxThreshold = new SuiTypeNumber(data.rxThreshold, undefined, -2.147483648e9, 2.147483647e9, 1);
        this.usedBandwidth = new SuiTypeNumber(data.usedBandwidth, undefined, 0.0, 2.147483647e9, 1);
    }

    toDto(): PdbOpModeConfigDTO {
        return {
            dataRate: this.dataRate.value,
            id: this.id.value,
            isEnabled: this.isEnabled.value,
            modulationAlias: this.modulationAlias.value,
            opModeName: this.opModeName.value,
            order: this.order,
            ptx: this.ptx.value,
            rxThreshold: this.rxThreshold.value,
            usedBandwidth: this.usedBandwidth.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.dataRate.validateAndShowError() &&
            this.id.validateAndShowError() &&
            this.isEnabled.validateAndShowError() &&
            this.modulationAlias.validateAndShowError() &&
            this.opModeName.validateAndShowError() &&
            this.ptx.validateAndShowError() &&
            this.rxThreshold.validateAndShowError() &&
            this.usedBandwidth.validateAndShowError()
        );
    }
}

export class SuiPlannerFeatureCollectionDTO {
    bbox: SuiTypeNumber[];
    crs: SuiConfigObjectsDTO;
    name: string;

    constructor(data: PlannerFeatureCollectionDTO) {
        this.bbox = (data.bbox ?? []).map((value) => new SuiTypeNumber(value, undefined, -2.147483648e9, 2.147483647e9));
        this.crs = new SuiConfigObjectsDTO(data.crs ?? ({} as ConfigObjectsDTO));
        this.name = data.name;
    }

    toDto(): PlannerFeatureCollectionDTO {
        return { bbox: this.bbox.map((element: SuiTypeNumber) => element.value), crs: this.crs?.toDto(), name: this.name };
    }

    validateAndShowError(): boolean {
        return this.bbox.every((element: SuiTypeNumber) => element.validateAndShowError()) && this.crs.validateAndShowError();
    }
}

export class SuiProductPortDto {
    name: SuiTypeEnum<PortNameEnum>;
    order: SuiTypeNumber;
    poeSupport: SuiTypeEnum<PoeSupportEnum>;
    speed: SuiTypeEnum<PortSpeedEnum>;
    type: SuiTypeEnum<PortTypeEnum>;

    constructor(data: ProductPortDto) {
        this.name = new SuiTypeEnum(
            data.name,
            [PortNameEnum.ETH1, PortNameEnum.ETH2, PortNameEnum.ETH3, PortNameEnum.ETH4, PortNameEnum.ETH5, PortNameEnum.ETH6],
            'PortNameEnum'
        );
        this.order = new SuiTypeNumber(data.order, 0, -2.147483648e9, 2.147483647e9);
        this.poeSupport = new SuiTypeEnum(data.poeSupport, [PoeSupportEnum.IN, PoeSupportEnum.OUT, PoeSupportEnum.NONE], 'PoeSupportEnum');
        this.speed = new SuiTypeEnum(data.speed, [PortSpeedEnum.GE_1, PortSpeedEnum.GE_10], 'PortSpeedEnum');
        this.type = new SuiTypeEnum(data.type, [PortTypeEnum.RJ45, PortTypeEnum.SFP, PortTypeEnum.SFP_PLUS], 'PortTypeEnum');
    }

    toDto(): ProductPortDto {
        return {
            name: this.name.value,
            order: this.order.value,
            poeSupport: this.poeSupport.value,
            speed: this.speed.value,
            type: this.type.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.name.validateAndShowError() &&
            this.order.validateAndShowError() &&
            this.poeSupport.validateAndShowError() &&
            this.speed.validateAndShowError() &&
            this.type.validateAndShowError()
        );
    }
}

export class SuiProjectDTO {
    buCount: number;
    bugReport: SuiTypeToggle;
    currentConfigurationId: number;
    customerId: number;
    customerName: string;
    description: SuiTypeString;
    engineType: EngineProcessTypeEnum;
    firstBomDate: Date;
    firstDesignDate: Date;
    id: number;
    lastEditDate: Date;
    lastEditDescription: string;
    lastEditUserId: string;
    linksCount: number;
    name: SuiTypeString;
    nodesCount: number;
    parentId: number;
    secondBomMailSent: boolean;
    secondDesignMailSent: boolean;
    tuCount: number;

    constructor(data: ProjectDTO) {
        this.buCount = data.buCount;
        this.bugReport = new SuiTypeToggle(data.bugReport, true, false);
        this.currentConfigurationId = data.currentConfigurationId;
        this.customerId = data.customerId;
        this.customerName = data.customerName;
        this.description = new SuiTypeString(data.description, undefined, 0, 255);
        this.engineType = data.engineType;
        this.firstBomDate = data.firstBomDate;
        this.firstDesignDate = data.firstDesignDate;
        this.id = data.id;
        this.lastEditDate = data.lastEditDate;
        this.lastEditDescription = data.lastEditDescription;
        this.lastEditUserId = data.lastEditUserId;
        this.linksCount = data.linksCount;
        this.name = new SuiTypeString(data.name, [new RegExp(/^[A-Za-z\d\s#@!;$&%()_+=.,~\-{}\[\]^'`]*$/)], 0, 255);
        this.name.isMandatory = true;
        this.nodesCount = data.nodesCount;
        this.parentId = data.parentId;
        this.secondBomMailSent = data.secondBomMailSent;
        this.secondDesignMailSent = data.secondDesignMailSent;
        this.tuCount = data.tuCount;
    }

    toDto(): ProjectDTO {
        return {
            buCount: this.buCount,
            bugReport: this.bugReport.value,
            currentConfigurationId: this.currentConfigurationId,
            customerId: this.customerId,
            customerName: this.customerName,
            description: this.description.value,
            engineType: this.engineType,
            firstBomDate: this.firstBomDate,
            firstDesignDate: this.firstDesignDate,
            id: this.id,
            lastEditDate: this.lastEditDate,
            lastEditDescription: this.lastEditDescription,
            lastEditUserId: this.lastEditUserId,
            linksCount: this.linksCount,
            name: this.name.value,
            nodesCount: this.nodesCount,
            parentId: this.parentId,
            secondBomMailSent: this.secondBomMailSent,
            secondDesignMailSent: this.secondDesignMailSent,
            tuCount: this.tuCount
        };
    }

    validateAndShowError(): boolean {
        return this.bugReport.validateAndShowError() && this.description.validateAndShowError() && this.name.validateAndShowError();
    }
}

export class SuiTopologyPreferencesDTO {
    iconScale: SuiTypeNumber;
    ptmpLinkLineOpacity: SuiTypeNumber;
    ptpLinkLineOpacity: SuiTypeNumber;
    sectorAreaOpacity: SuiTypeNumber;
    sectorsLineOpacity: SuiTypeNumber;
    textScale: SuiTypeNumber;
    wiredLinkLineOpacity: SuiTypeNumber;

    constructor(data: TopologyPreferencesDTO) {
        this.iconScale = new SuiTypeNumber(data.iconScale, 0.0, 0.0, 100.0);
        this.ptmpLinkLineOpacity = new SuiTypeNumber(data.ptmpLinkLineOpacity, 0.0, 0.0, 100.0);
        this.ptpLinkLineOpacity = new SuiTypeNumber(data.ptpLinkLineOpacity, 0.0, 0.0, 100.0);
        this.sectorAreaOpacity = new SuiTypeNumber(data.sectorAreaOpacity, 0.0, 0.0, 100.0);
        this.sectorsLineOpacity = new SuiTypeNumber(data.sectorsLineOpacity, 0.0, 0.0, 100.0);
        this.textScale = new SuiTypeNumber(data.textScale, 0.0, 0.0, 100.0);
        this.wiredLinkLineOpacity = new SuiTypeNumber(data.wiredLinkLineOpacity, 0.0, 0.0, 100.0);
    }

    toDto(): TopologyPreferencesDTO {
        return {
            iconScale: this.iconScale.value,
            ptmpLinkLineOpacity: this.ptmpLinkLineOpacity.value,
            ptpLinkLineOpacity: this.ptpLinkLineOpacity.value,
            sectorAreaOpacity: this.sectorAreaOpacity.value,
            sectorsLineOpacity: this.sectorsLineOpacity.value,
            textScale: this.textScale.value,
            wiredLinkLineOpacity: this.wiredLinkLineOpacity.value
        };
    }

    validateAndShowError(): boolean {
        return (
            this.iconScale.validateAndShowError() &&
            this.ptmpLinkLineOpacity.validateAndShowError() &&
            this.ptpLinkLineOpacity.validateAndShowError() &&
            this.sectorAreaOpacity.validateAndShowError() &&
            this.sectorsLineOpacity.validateAndShowError() &&
            this.textScale.validateAndShowError() &&
            this.wiredLinkLineOpacity.validateAndShowError()
        );
    }
}
